var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetched)?_c('mu-chip',{staticClass:"chip-item",attrs:{"delete":!_vm.isSubmitted},on:{"click":_vm.onClickPlay,"delete":_vm.onDelete}},[_c('mu-icon',{attrs:{"value":"play_arrow"}}),_vm._v(" "+_vm._s(_vm.computedDuration)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }